var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-empty-pattern */
import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import { SnackbarComponent } from '../..';
import { allDataFilter, config_baseURL, isBaseURLAll, set_account_override } from '../../../api/utils';
import { AccessRoles } from '../../../constants/AccessLevel';
import useNoInitialEffect from '../../../hooks/react-mod-hooks';
import { AccountSelector } from '../../commons/AccountSelector';
import { SideBarComponent } from '../../commons/SideBarComponent';
import { getRemovedTimeZoneBuff } from '../../commons/utils/DateFormatter';
import { changeDTSTART, removeUntil } from '../../commons/utils/RRulesUtils';
import { SchedulerConfigurator } from '../SchedulerConfigurator';
import { Calendar } from './Calendar';
import { HolidayConfigurator } from './Calendar/HolidayConfigurator';
import { ButtonWrapper, Content, Title, TitleWrapper, Wrapper, } from './SchedulerMainView.Styles';
import { Viewer } from '../SchedulerConfigurator/Viewer';
export var SchedulerMainView = function (_a) {
    var schedules = _a.schedules, holidays = _a.holidays, schedulesBetweenTimes = _a.schedulesBetweenTimes, scheduleEvents = _a.scheduleEvents, campaigns = _a.campaigns, campaignGroups = _a.campaignGroups, contactFilters = _a.contactFilters, phoneFilters = _a.phoneFilters, contactSorting = _a.contactSorting, contactLists = _a.contactLists, campaign = _a.campaign, studioFlows = _a.studioFlows, accessLevel = _a.accessLevel, selectedAccount = _a.selectedAccount, setAccount = _a.setAccount, getOneCampaign = _a.getOneCampaign, getSchedules = _a.getSchedules, getHolidays = _a.getHolidays, getCampaigns = _a.getCampaigns, getContactFlowList = _a.getContactFlowList, getContactFilters = _a.getContactFilters, getPhoneFilters = _a.getPhoneFilters, getContactSorting = _a.getContactSorting, getContactLists = _a.getContactLists, resetCampaign = _a.resetCampaign, deleteScheduleByID = _a.deleteScheduleByID, updateScheduleByID = _a.updateScheduleByID, updateOccurrenceID = _a.updateOccurrenceID, enableScheduleDate = _a.enableScheduleDate, addSchedule = _a.addSchedule, tempDialerDefaults = _a.dialerDefaults, getDialerDefaults = _a.getDialerDefaults, getSchedulesBetweenTimes = _a.getSchedulesBetweenTimes, addHoliday = _a.addHoliday, updateHoliday = _a.updateHoliday, deleteHoliday = _a.deleteHoliday, getGroups = _a.getGroups;
    var dateNow = new Date(), y = dateNow.getFullYear(), m = dateNow.getMonth();
    var _b = useState(false), readOnly = _b[0], setReadOnly = _b[1];
    var _c = useState(false), openSidebar = _c[0], setOpenSidebar = _c[1];
    var _d = useState(false), holidaySideBar = _d[0], setHolidaySideBar = _d[1];
    // const [scheduleEvents, setScheduleEvents] = useState([]);
    var _e = useState(false), openAlert = _e[0], setOpenAlert = _e[1];
    var _f = useState(''), alertMessage = _f[0], setAlertMessage = _f[1];
    var _g = useState(false), openSnack = _g[0], setOpenSnack = _g[1];
    var _h = useState(''), snackMessage = _h[0], setSnackMessage = _h[1];
    var _j = useState('success'), severity = _j[0], setSeverity = _j[1];
    var _k = useState(''), alertTitle = _k[0], setAlertTitle = _k[1];
    var _l = useState(''), dataId = _l[0], setDataId = _l[1];
    var _m = useState(), dataDates = _m[0], setDataDates = _m[1];
    var _o = useState(false), creating = _o[0], setCreating = _o[1];
    var _p = useState(), selectedSched = _p[0], setSelectedSched = _p[1];
    var _q = useState(), selectedHoliday = _q[0], setSelectedHoliday = _q[1];
    var _r = useState('series'), modType = _r[0], setModType = _r[1];
    var _s = useState(''), occurrenceDate = _s[0], setOccurrenceDate = _s[1];
    var _t = useState(moment.tz.guess()), calendarTimeZone = _t[0], setCalendarTimeZone = _t[1];
    var _u = useState({
        start: new Date(y, m, 1),
        end: new Date(y, m + 1, 6)
    }), calendarDateRange = _u[0], setCalendarDateRange = _u[1];
    var _v = useState(tempDialerDefaults), dialerDefaults = _v[0], setGlobalDefaults = _v[1];
    var _w = useState(config_baseURL()), accountURL = _w[0], setAccountURL = _w[1];
    var _x = useState(), enableSchedule = _x[0], setEnableSchedule = _x[1];
    var _y = useState(true), skipModal = _y[0], setSkipModal = _y[1];
    var _z = useState(false), openExportDialog = _z[0], setOpenExportDialog = _z[1];
    var _0 = useState(), selectedExportSchedule = _0[0], setSelectedExportSchedule = _0[1];
    var handleSideBar = function () {
        setHolidaySideBar(true);
        setCreating(true);
        handleOpenSideBar();
    };
    var handleOpenSideBar = function (readOnly) {
        setOpenSidebar(true);
        setSkipModal(true);
        if (!readOnly && accessLevel !== AccessRoles.READ_ONLY)
            localStorage.setItem('onEditMode', '1');
    };
    useEffect(function () {
        getSchedules();
        getHolidays();
        getCampaigns();
        getContactFilters();
        getPhoneFilters();
        getContactSorting();
        resetCampaign();
        getContactFlowList();
        getDialerDefaults();
        getContactLists();
        getGroups();
    }, [selectedAccount]);
    useEffect(function () {
        if (Array.isArray(tempDialerDefaults)) {
            var temp = tempDialerDefaults.find(function (tg) { return tg.prjacc.url === config_baseURL(); });
            setGlobalDefaults(temp);
        }
        else {
            setGlobalDefaults(tempDialerDefaults);
        }
    }, [accountURL, tempDialerDefaults]);
    useNoInitialEffect(function () {
        set_account_override('1');
        if (!isBaseURLAll()) {
            getCampaigns();
            getContactFilters();
            getPhoneFilters();
            getContactSorting();
            getContactFlowList();
            getDialerDefaults();
            getContactLists();
            getGroups();
        }
        return function () { return set_account_override('0'); };
    }, [accountURL]);
    useEffect(function () {
        if (severity === 'success' && openSnack) {
            getSchedulesBetweenTimes(calendarDateRange === null || calendarDateRange === void 0 ? void 0 : calendarDateRange.start, calendarDateRange === null || calendarDateRange === void 0 ? void 0 : calendarDateRange.end, true);
        }
    }, [openSnack]);
    var pollSchedulesBetweenTimes = function () { return __awaiter(void 0, void 0, void 0, function () {
        var timezoneOffsetHours, todayStart, todayEnd;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    timezoneOffsetHours = new Date().getTimezoneOffset() / 60;
                    todayStart = new Date(new Date().setHours(0 + timezoneOffsetHours, 0, 0));
                    todayEnd = new Date(new Date().setHours(23 + timezoneOffsetHours, 59, 59));
                    return [4 /*yield*/, getSchedulesBetweenTimes(todayStart, todayEnd)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var pollTimer = setInterval(pollSchedulesBetweenTimes, 60 * 1000);
        return function () { return clearInterval(pollTimer); };
    }, [selectedAccount]);
    var handleAlertClose = function () {
        setOpenAlert(false);
    };
    var onDeleteSeries = function () {
        if (modType === 'series') {
            deleteScheduleByID(dataId, modType, '', function (data) {
                handleDeleteCallback(data);
            });
        }
        else {
            deleteScheduleByID(dataId, modType, occurrenceDate, function (data) {
                handleDeleteCallback(data);
            });
        }
        setOpenAlert(false);
    };
    var onEdit = function (data_id, data, type, readOnly) {
        var _a;
        var selectedSchdlEvent = scheduleEvents.schedules.find(function (sched) { return sched.schedule.id === data_id; });
        var selectedSchdl = __assign(__assign({}, selectedSchdlEvent.schedule), { ScheduleTimeZone: selectedSchdlEvent.scheduleTimezone });
        if (isBaseURLAll()) {
            selectedSchdl['prjacc'] = selectedSchdlEvent === null || selectedSchdlEvent === void 0 ? void 0 : selectedSchdlEvent['prjacc'];
        }
        setDataId(data_id);
        handleOpenSideBar(readOnly);
        setCreating(false);
        setModType(type);
        setDataDates(data);
        if (type === 'occurrence') {
            var rrule = changeDTSTART(((_a = selectedSchdl.Occurrence.Recurring) === null || _a === void 0 ? void 0 : _a.RRule) || '', selectedSchdlEvent.scheduleTimezone
                ? new Date(getRemovedTimeZoneBuff(new Date(data.start), selectedSchdlEvent.scheduleTimezone))
                : data.start);
            rrule = removeUntil(rrule);
            setSelectedSched(__assign(__assign({}, selectedSchdl), { Occurrence: __assign(__assign({}, selectedSchdl.Occurrence), { Recurring: __assign(__assign({}, selectedSchdl.Occurrence.Recurring), { RRule: rrule }) }) }));
            // TODO: Detect is the occurrence has already running
            // if(selectedSchdlEvent.occurrences.find(
            //   (oc) => oc.start === data.start.toISOString(),
            // )?.status==='FINISHED'){
            // }
        }
        else {
            setSelectedSched(selectedSchdl);
        }
    };
    var onCopy = function (data_id, data, type) {
        var _a;
        var selectedSchdlEvent = scheduleEvents.schedules.find(function (sched) { return sched.schedule.id === data_id; });
        var selectedSchdl = __assign(__assign({}, selectedSchdlEvent.schedule), { ScheduleTimeZone: selectedSchdlEvent.scheduleTimezone });
        if (isBaseURLAll()) {
            selectedSchdl['prjacc'] = selectedSchdlEvent === null || selectedSchdlEvent === void 0 ? void 0 : selectedSchdlEvent['prjacc'];
        }
        setDataId(data_id);
        handleOpenSideBar();
        setCreating(true);
        setModType(type);
        setDataDates(data);
        if (type === 'occurrence') {
            var rrule = changeDTSTART(((_a = selectedSchdl.Occurrence.Recurring) === null || _a === void 0 ? void 0 : _a.RRule) || '', selectedSchdlEvent.scheduleTimezone
                ? new Date(getRemovedTimeZoneBuff(new Date(data.start), selectedSchdlEvent.scheduleTimezone))
                : data.start);
            rrule = removeUntil(rrule);
            setSelectedSched(__assign(__assign({}, selectedSchdl), { Occurrence: __assign(__assign({}, selectedSchdl.Occurrence), { Recurring: __assign(__assign({}, selectedSchdl.Occurrence.Recurring), { RRule: rrule }) }) }));
        }
        else {
            setSelectedSched(selectedSchdl);
        }
    };
    var onExport = function (data_id) {
        var selectedSchdlEvent = scheduleEvents.schedules.find(function (sched) { return sched.schedule.id === data_id; });
        var selectedSchdl = __assign(__assign({}, selectedSchdlEvent.schedule), { ScheduleTimeZone: selectedSchdlEvent.scheduleTimezone });
        setSelectedExportSchedule(selectedSchdl);
        setOpenExportDialog(true);
    };
    var onDelete = function (data_id, date, discard) {
        setDataId(data_id);
        setOpenAlert(true);
        setOccurrenceDate(date);
        setAlertTitle('Delete Schedule Series');
        setAlertMessage('Are you sure you want to delete this series? All events will be deleted.');
        discard();
    };
    var onEnable = function (data) {
        var _a, _b;
        var status = data.action.type;
        var conflict = (_a = data.error) === null || _a === void 0 ? void 0 : _a.status;
        if (conflict === 409 || ((_b = data.error) === null || _b === void 0 ? void 0 : _b.conflictingOccurrence)) {
            setSnackMessage("Schedule Overlap Conflict appears on " + data.error.conflictingOccurrence);
            setSeverity('warning');
        }
        else {
            switch (status) {
                case "UPDATE_SCHEDULER_FULFILLED":
                case "UPDATE_OCCURRENCE_FULFILLED":
                case "DISABLE_SCHEDULER_FULFILLED":
                case "ENABLE_SCHEDULER_FULFILLED":
                case "DISABLE_OCCURRENCE_FULFILLED":
                case "ENABLE_OCCURRENCE_FULFILLED":
                    setSnackMessage('Success!');
                    setSeverity('success');
                    break;
                default:
                    setSnackMessage('Failed!');
                    setSeverity('error');
                    break;
            }
        }
        setOpenSnack(true);
    };
    var handleUpdateCallback = function (data, discard) {
        var _a, _b, _c;
        var status = data.action.type;
        var conflict = (_a = data.error) === null || _a === void 0 ? void 0 : _a.status;
        if (status === 'UPDATE_SCHEDULER_FULFILLED') {
            setSnackMessage('Schedule Updated!');
            setSeverity('success');
            discard();
        }
        else if (status === 'UPDATE_OCCURRENCE_FULFILLED') {
            setSnackMessage('Schedule Occurrence Updated!');
            setSeverity('success');
            discard();
        }
        else if (conflict === 409 || ((_b = data.error) === null || _b === void 0 ? void 0 : _b.conflictingOccurrence)) {
            setSnackMessage("Schedule Overlap Conflict appears on " + data.error.conflictingOccurrence);
            setSeverity('warning');
        }
        else if (data.errorMessage && data.errorMessage.includes('409')) {
            setSnackMessage('Data state is stale; refresh & retry!');
            setSeverity('error');
        }
        else {
            if (((_c = data === null || data === void 0 ? void 0 : data.action) === null || _c === void 0 ? void 0 : _c.message) === 'Not Found') {
                setSnackMessage('Schedule Update Failed, Schedule Not Found!');
            }
            else {
                setSnackMessage('Schedule Update Failed!');
            }
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    var handleAddCallback = function (data, discard) {
        var _a, _b;
        var status = data.action.type;
        var conflict = (_a = data.error) === null || _a === void 0 ? void 0 : _a.status;
        if (status === 'ADD_SCHEDULER_FULFILLED') {
            setSnackMessage('Schedule Created!');
            setSeverity('success');
            discard();
        }
        else if (conflict === 409 || ((_b = data.error) === null || _b === void 0 ? void 0 : _b.conflictingOccurrence)) {
            setSnackMessage("Schedule Overlap Conflict appears on " + data.error.conflictingOccurrence);
            setSeverity('warning');
        }
        else {
            setSnackMessage('Schedule Creation Failed!');
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    var handleDeleteCallback = function (data) {
        var status = data.action.type;
        if (status === 'DELETE_SCHEDULER_FULFILLED') {
            setSnackMessage('Schedule Series Deleted!');
            setSeverity('success');
        }
        else if (status === 'DELETE_OCCURRENCE_FULFILLED') {
            setSnackMessage('Schedule Occurrence Deleted!');
            setSeverity('success');
        }
        else {
            setSnackMessage('Schedule Series Deletion Failed!');
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    var handleAddHolidayCallback = function (data, discard) {
        var status = data.action.type;
        if (status === 'ADD_HOLIDAY_FULFILLED') {
            setSnackMessage('Holiday Created!');
            setSeverity('success');
            discard();
        }
        else {
            setSnackMessage('Holiday Creation Failed!');
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    var handleUpdateHolidayCallback = function (data, discard) {
        var status = data.action.type;
        if (status === 'UPDATE_HOLIDAY_FULFILLED') {
            setSnackMessage('Holiday Updated!');
            setSeverity('success');
            discard();
        }
        else {
            setSnackMessage('Holiday Updated Failed!');
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    var handleDeleteHolidayCallback = function (data, discard) {
        var status = data.action.type;
        if (status === 'DELETE_HOLIDAY_FULFILLED') {
            setSnackMessage('Holiday Deleted!');
            setSeverity('success');
            discard();
        }
        else {
            setSnackMessage('Holiday Deletion Failed!');
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    var alertReadOnly = function () {
        setSnackMessage('Access Denied');
        setSeverity('info');
        setOpenSnack(true);
    };
    var onHolidayEdit = function (holiday) {
        setSelectedHoliday(holiday);
        setCreating(false);
        setHolidaySideBar(true);
        handleOpenSideBar();
    };
    var handleEnableHolidayOverRide = function (data_id, reason) {
        var _a;
        var schedule = (_a = scheduleEvents.schedules.find(function (sched) { return sched.schedule.id === data_id; })) === null || _a === void 0 ? void 0 : _a.schedule;
        if (schedule) {
            var template = __assign(__assign({}, schedule), { Occurrence: {
                    Single: {
                        Date: reason.date,
                        Parent: data_id
                    },
                    Duration: schedule.Occurrence.Duration
                } });
            updateOccurrenceID(template, data_id, reason.date, function (data) {
                var status = data.action.type;
                if (status === 'UPDATE_OCCURRENCE_FULFILLED') {
                    setSnackMessage('Schedule Occurrence Transformed and Enabled!');
                    setSeverity('success');
                    setOpenSnack(true);
                }
            });
        }
    };
    return (React.createElement(Wrapper, null,
        React.createElement(TitleWrapper, null,
            React.createElement(Title, { variant: 'h6' }, "Scheduler"),
            React.createElement(ButtonWrapper, null,
                React.createElement(AccountSelector, { initialValue: selectedAccount, onValueChange: function (data) { return setAccount(data); }, disabled: openSidebar }),
                React.createElement(Button, { disabled: openSidebar, variant: 'contained', color: 'primary', size: 'small', onClick: function () {
                        handleOpenSideBar();
                        setSelectedSched({});
                        setCreating(true);
                    } }, accessLevel === AccessRoles.READ_ONLY
                    ? 'See Form'
                    : 'New Schedule'))),
        React.createElement(SideBarComponent, { topOffSet: 47, open: openSidebar, readonly: readOnly || accessLevel === AccessRoles.READ_ONLY, onClose: function () {
                setSkipModal(true);
                resetCampaign();
            }, component: holidaySideBar ? (React.createElement(HolidayConfigurator, { holidays: holidays, onAlert: function (message, severity) {
                    setSnackMessage(message);
                    setSeverity(severity);
                    setOpenSnack(true);
                }, onDiscardClick: function () {
                    setOpenSidebar(false);
                    setHolidaySideBar(false);
                    setReadOnly(false);
                    setSelectedHoliday({});
                    localStorage.setItem('onEditMode', '0');
                }, creating: creating, onSubmit: function (form) { return form; }, addHoliday: function (holiday, discard) {
                    addHoliday(holiday, function (data) {
                        handleAddHolidayCallback(data, discard);
                    });
                }, updateHoliday: function (holiday, initialHoliday, discard) {
                    updateHoliday(holiday, initialHoliday, function (data) {
                        handleUpdateHolidayCallback(data, discard);
                    });
                }, deleteHoliday: function (id, discard) {
                    deleteHoliday(id, function (data) {
                        handleDeleteHolidayCallback(data, discard);
                    });
                }, holiday: selectedHoliday, setSelectedHD: function (data) { return setSelectedHoliday(data); }, onAccountChange: function (url) { return setAccountURL(url); } })) : (React.createElement(SchedulerConfigurator, { readOnly: readOnly || accessLevel === AccessRoles.READ_ONLY, onDiscardClick: function () {
                    setOpenSidebar(false);
                    setReadOnly(false);
                    localStorage.setItem('onEditMode', '0');
                }, setSelectedSched: function (data) { return setSelectedSched(data); }, scheduleEvents: allDataFilter(scheduleEvents, 'no-array'), schedules: allDataFilter(schedules), campaigns: allDataFilter(campaigns), studioFlows: allDataFilter(studioFlows), contactFilters: allDataFilter(contactFilters), phoneFilters: allDataFilter(phoneFilters), onCampaignChange: function () { return setSkipModal(false); }, contactSorting: allDataFilter(contactSorting), contactLists: allDataFilter(contactLists), skipModal: skipModal, campaign: campaign, getOneCampaign: getOneCampaign, dialerDefaults: dialerDefaults, creating: creating, selectedSched: selectedSched, updateSchedule: function (editedScheduleConfig, id, date, discard, initialScheduleConfig) {
                    if (modType === 'series') {
                        updateScheduleByID(editedScheduleConfig, id, function (data) {
                            handleUpdateCallback(data, discard);
                        }, initialScheduleConfig);
                    }
                    else if (modType === 'occurrence') {
                        updateOccurrenceID(editedScheduleConfig, id, dataDates ? new Date(dataDates.start).toISOString() : date, function (data) {
                            handleUpdateCallback(data, discard);
                        });
                    }
                }, addSchedule: function (schedule, discard) {
                    addSchedule(schedule, function (data) {
                        handleAddCallback(data, discard);
                    });
                }, onDelete: function (data_id, date, discard) {
                    if (accessLevel === AccessRoles.READ_ONLY) {
                        alertReadOnly();
                    }
                    else {
                        onDelete(data_id, date, discard);
                    }
                }, onAlert: function (data, severity) {
                    setSnackMessage(data);
                    setSeverity(severity);
                    setOpenSnack(true);
                }, modType: modType, calendarTimeZone: calendarTimeZone, schedulesBetweenTimes: allDataFilter(schedulesBetweenTimes), onAccountChange: function (url) { return setAccountURL(url); }, getSchedulesBetweenTimes: getSchedulesBetweenTimes })) },
            React.createElement(Content, null,
                React.createElement(Calendar, { selectedAccount: selectedAccount, scheduleEvents: scheduleEvents, schedulesBetweenTimes: schedulesBetweenTimes, campaignGroups: campaignGroups, dialerDefaults: dialerDefaults, handleSideBar: handleSideBar, openSidebar: openSidebar, onEdit: function (data_id, data, type) {
                        if (accessLevel === AccessRoles.READ_ONLY) {
                            alertReadOnly();
                        }
                        else {
                            onEdit(data_id, data, type);
                            if (type === 'series') {
                                setSnackMessage('This will only affect current and future schedules.');
                                setSeverity('info');
                                setOpenSnack(true);
                            }
                        }
                    }, onCopy: function (data_id, data, type) {
                        if (accessLevel === AccessRoles.READ_ONLY) {
                            alertReadOnly();
                        }
                        else {
                            onCopy(data_id, data, type);
                        }
                    }, onEnable: function (data_id, date, type, enable, reason) {
                        if (accessLevel === AccessRoles.READ_ONLY) {
                            alertReadOnly();
                        }
                        else if (reason && reason.disabledReason === 'holiday') {
                            handleEnableHolidayOverRide(data_id, reason);
                        }
                        else {
                            enableScheduleDate(data_id, date, type, enable, function (data) {
                                onEnable(data);
                            });
                        }
                    }, onView: function (data_id, data, type) {
                        setReadOnly(true);
                        onEdit(data_id, data, type, true);
                    }, onExport: function (data_id) { return onExport(data_id); }, onTimeZoneChange: function (timezone) { return setCalendarTimeZone(timezone); }, campaigns: campaigns, getSchedulesBetweenTimes: function (todayStart, todayEnd) {
                        return getSchedulesBetweenTimes(todayStart, todayEnd, true);
                    }, onHolidayEdit: function (holiday) {
                        if (accessLevel === AccessRoles.READ_ONLY) {
                            alertReadOnly();
                        }
                        else {
                            onHolidayEdit(holiday);
                        }
                    }, onRangeChange: function (dateRage) { return setCalendarDateRange(dateRage); } }))),
        React.createElement(Dialog, { open: openAlert, onClose: function () { return handleAlertClose(); }, "aria-labelledby": 'alert-delete', "aria-describedby": 'alert-dialog-description' },
            React.createElement(DialogTitle, { id: 'alert-delete' }, alertTitle),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, { id: 'alert-dialog-description' }, alertMessage)),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: function () { return handleAlertClose(); }, color: 'primary' }, "Disagree"),
                React.createElement(Button, { onClick: function () {
                        onDeleteSeries();
                    }, color: 'primary', autoFocus: true }, "Agree"))),
        React.createElement(SnackbarComponent, { open: openSnack, anchorOrigin: { vertical: 'top', horizontal: 'center' }, onAlertClose: function () { return setOpenSnack(false); }, autoHideDuration: 5000, alertMessage: snackMessage, severity: severity }),
        React.createElement(Viewer, { formData: {}, open: openExportDialog, onClose: function (open) { return setOpenExportDialog(open); }, scheduleData: selectedExportSchedule, calendarTimeZone: calendarTimeZone, modType: modType, contactFilters: allDataFilter(contactFilters), contactSorting: allDataFilter(contactSorting), phoneFilters: allDataFilter(phoneFilters) })));
};
SchedulerMainView.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=SchedulerMainView.js.map